// Auth + agent
export const setAgentId = (currentAgentId) => ({
  type: "SET_AGENT_ID",
  payload: currentAgentId,
});
export const setAgentType = (agentType) => ({
  type: "SET_AGENT_TYPE",
  payload: agentType,
});
export const setAgentName = (agentName) => ({
  type: "SET_AGENT_NAME",
  payload: agentName,
});
export const clearAuth = () => ({ type: "CLEAR_AUTH" });

// Insurance flow
export const setInsuranceType = (insuranceType) => ({
  type: "SET_INSURANCE_TYPE",
  payload: insuranceType,
});
export const setCaseId = (caseId) => ({
  type: "SET_CASE_ID",
  payload: caseId,
});
export const setOcrData = (ocrData) => ({
  type: "SET_OCR_DATA",
  payload: ocrData,
});
export const setPlanName = (planName) => ({
  type: "SET_PLAN_NAME",
  payload: planName,
});
export const setTravelPlanningType = (planningType) => ({
  type: "SET_TRAVEL_PLANNING_TYPE",
  payload: planningType,
});
export const setPetType = (petType) => ({
  type: "SET_PET_TYPE",
  payload: petType,
});

// Single, product-agnostic compare slice. The `product` key disambiguates
// which product the schemes belong to so the compare screen knows where
// to navigate back to.
export const setCompareSchemes = (product, schemes) => ({
  type: "SET_COMPARE_SCHEMES",
  payload: { product, schemes },
});
export const clearCompareSchemes = () => ({ type: "CLEAR_COMPARE_SCHEMES" });

// Journey progress. Tracks the furthest step index the user has legitimately
// reached in each funnel, which is what lets the stepper turn completed steps
// into back-navigation links without ever allowing a forward skip.
export const markStepReached = (journey, index) => ({
  type: "MARK_STEP_REACHED",
  payload: { journey, index },
});
// The answers given so far, per journey. The navigation ribbon renders these
// as editable chips, so it needs them client-side rather than having to refetch
// the case record on every step.
export const recordAnswers = (journey, values) => ({
  type: "RECORD_ANSWERS",
  payload: { journey, values },
});

export const resetJourneyProgress = (journey) => ({
  type: "RESET_JOURNEY_PROGRESS",
  payload: { journey },
});
